import React from 'react';
import webdevelopment from '../images/web-development.png';
import futureofwebdesigning from '../images/Future-of-Web-Designing.jpg';

const Services = () => {
	return (
		<div
			id='services'
			className='flex flex-col justify-center text-center mt-32 p-16 bg-[#dee6e7]'
		>
			<h1 className='text-4xl mb-16 sm:text-5xl md:text-6xl'>Services</h1>
			<div className='flex flex-col m-8 justify-center items-center space-y-12 md:flex-row md:space-x-12 md:space-y-0'>
				<div
					className='flex flex-col justify-center border-2 border-blue-400 p-4 rounded-lg items-center min-w-[260px] 
					sm:text-lg md:text-xl hover:-translate-y-6 hover:scale-105 ease-in-out duration-300 shadow-xl
				'
				>
					<img
						src={webdevelopment}
						alt='webdevelopment'
						className='h-20 w-20 mx-auto rounded-full sm:h-28 sm:w-28'
					/>
					<h3 className='text-3xl mt-4'>Development</h3>
					<p className='max-w-[500px] mt-4'>
						HTML5, CSS3, JavaScript, React Js. microformats, semantics and
						more... From simple one-page websites to custom interactive
						applications.
					</p>
				</div>
				<div
					className='flex flex-col justify-center border-2 border-blue-400 p-4 rounded-lg items-center min-w-[260px] 
					sm:text-lg md:text-xl hover:-translate-y-6 hover:scale-105 ease-in-out duration-300 shadow-xl'
				>
					<img
						src={futureofwebdesigning}
						alt='futureofwebdesigning'
						className='h-20 w-20 mx-auto rounded-full sm:h-28 sm:w-28'
					/>
					<h3 className='text-3xl mt-4'>Design</h3>
					<p className='max-w-[500px] mt-4'>
						I design eye-catching websites and interfaces that help visitors
						find what they looking for, also with creative, sustainable and
						responsive way.
					</p>
				</div>
			</div>
		</div>
	);
};

export default Services;
